<ion-range aria-label="Selector de fechas" [min]="rangeMinValue" [max]="rangeMaxValue" [pin]="true" [value]="rangeValue"
  [ticks]="true" [snaps]="true" [pinFormatter]="dateValueFormatter" [dualKnobs]="isRange"
  (ionChange)="onRangeChange($event)">

  <div id="start-date-label" slot="start">{{dateFormater(minDate)}}</div>
  <div id="end-date-label" slot="end">{{dateFormater(maxDate)}}</div>

</ion-range>


<ion-popover trigger="start-date-label" side="top" alignment="center">
  <ng-template>
    <ion-datetime locale="es-ES" presentation="date" [value]="minDate" [max]="maxDate" [showDefaultButtons]="true"
      doneText="Aceptar" cancelText="Cancelar" (ionChange)="changeRangeLimit('min', $event)"></ion-datetime>
  </ng-template>
</ion-popover>

<ion-popover trigger="end-date-label" side="top" alignment="start" style="left: -50px;">
  <ng-template>
    <ion-datetime locale="es-ES" presentation="date" [value]="maxDate" [min]="minDate" [showDefaultButtons]="true"
      doneText="Aceptar" cancelText="Cancelar" (ionChange)="changeRangeLimit('max', $event)"></ion-datetime>
  </ng-template>
</ion-popover>